import { useThreadsStore } from "@/react/hooks/chatsV2/store";
import type {
  ChatRoomMessage,
  ChatRoomMessageSearchResult,
} from "@/react/types/Chat/ChatRoomMessage";
import { useChatThreadsApi } from "@circle-react/hooks/chatsV2/useChatThreadsApi";
import { TwoWayPagination } from "@circle-react-shared/Pagination/TwoWayPagination";

interface ChatThreadsBodyProps {
  chatRoomUuid: string;
  children: React.ReactNode;
  isFirstPage: boolean;
  isLastPage: boolean;
  parentMessage: ChatRoomMessage | ChatRoomMessageSearchResult;
  setIsFirstPage: (isFirstPage: boolean) => void;
  setIsLastPage: (isLastPage: boolean) => void;
}

export const ChatThreadsBody = ({
  children,
  isLastPage,
  isFirstPage,
  setIsFirstPage,
  setIsLastPage,
  chatRoomUuid,
  parentMessage,
}: ChatThreadsBodyProps) => {
  const { fetchChatMessages } = useChatThreadsApi();
  const { hasNextPage, hasPrevPage, isLoading, firstMessageId, lastMessageId } =
    useThreadsStore();
  return (
    <TwoWayPagination
      shouldShowPrevLoader={!isLastPage}
      shouldShowNextLoader={!isFirstPage}
      hasNextPage={hasNextPage}
      hasPrevPage={hasPrevPage}
      onNextPage={messageId => {
        void fetchChatMessages({
          chatRoomUuid,
          id: messageId,
          previousPerPage: 0,
          nextPerPage: 20,
          parentMessage,
        });
        setIsFirstPage(false);
      }}
      onPrevPage={messageId => {
        void fetchChatMessages({
          chatRoomUuid,
          id: messageId,
          parentMessage,
        });
        setIsLastPage(false);
      }}
      firstItemId={firstMessageId}
      lastItemId={lastMessageId}
      componentId="message-thread-scroll-view"
      isLoading={isLoading}
    >
      {children}
    </TwoWayPagination>
  );
};
